export default {
    vehss_condition_1: 'Age-related macular degeneration',
    vehss_condition_2: 'Diabetic retinopathy',
    vehss_condition_3: 'Retinal vein occlusion',
    vehss_condition_11: 'Early age-related macular degeneration',
    vehss_condition_12: 'Late age-related macular degeneration',
    vehss_condition_21: 'Non-vision-threatening diabetic retinopathy',
    vehss_condition_22: 'Vision-threatening diabetic retinopathy',
    vehss_condition_23: 'Diabetic macular edema',
};
